import axios from "axios";
import Vue from "vue";
export const state = {
  schools: [],
  save_status: false,
};
export const getters = {
  AllSchools: (state) => state.schools.data,
  SaveStatus: (state) => state.save_status,
};

export const mutations = {
  SET_SCHOOLS(state, newValue) {
    state.schools = newValue;
  },
  SET_SAVE_STATUS(state, newValue) {
    state.save_status = newValue;
  },
  pushNotification(state, payload) {
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};

export const actions = {
  //add school
  addSchool({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post("schools", payload)
      .then(() => {
        dispatch("fetchSchools");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "School Added Successfully",
        };
        commit("pushNotification", message);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While. <b>Adding School</b>",
        };
        commit("pushNotification", message);
      });
  },
  // Edit School
  editSchool({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`schools/edit`, payload.details)
      .then(() => {
        dispatch("fetchSchools");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "School Edited Successfully",
        };
        commit("pushNotification", message);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While. <b>Editing School</b>",
        };
        commit("pushNotification", message);
      });
  },
  // School License
  schoolLicense({ commit }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .post(`license/school`, payload)
      .then(() => {
        // dispatch('fetchSchools');
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "School License Added Successfully",
        };
        commit("pushNotification", message);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While. <b>Adding School License</b>",
        };
        commit("pushNotification", message);
      });
  },
  // Delete School
  deleteSchool({ commit, dispatch }, payload) {
    commit("SET_SAVE_STATUS", true);
    axios
      .delete(`schools/${payload.id}`)
      .then(() => {
        dispatch("fetchSchools");
        const message = {
          type: "success",
          title: "<b>Success Notifications</b>",
          message: "School Deleted Successfully",
        };
        commit("pushNotification", message);
      })
      .catch(() => {
        commit("SET_SAVE_STATUS", false);
        const message = {
          type: "error",
          title: "<b>Error Notifications</b>",
          message: "An Error Occurred While. <b>Deleting School</b>",
        };
        commit("pushNotification", message);
      });
  },
  //fetching all schools
  fetchSchools({ commit }) {
    axios.get("schools").then((schools) => {
      commit("SET_SCHOOLS", schools.data);
      commit("SET_SAVE_STATUS", false);
    });
  },
};
